import React, { lazy, Suspense } from 'react';

const Popup = lazy(() => import('./popup'));

const PopupRoot = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return <div />;
  }

  return (
    <Suspense fallback={() => <div />}>
      <Popup />
    </Suspense>
  );
};

export default PopupRoot;
